module.exports = "/_next/static/images/umbrella-537b15c8c3572115ada05db4cea64a75.svg";